import React, { useMemo, useState } from 'react';

import { add, sub, isValid, isBefore, isAfter, startOfDay, endOfDay, formatISO } from 'date-fns';
import { Container, DateRangeContainer, DateField, HelpText, Button, Link, ModalDeactive } from './styles';

const SearchDateRange = ({ onSearchByDateRange }) => {
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [errors, setErrors] = useState(null);

  const maxEndDate = useMemo(() => {
    return startDate ? add(startDate, { days: 29 }) : undefined;
  }, [startDate]);

  const minStartDate = useMemo(() => {
    return endDate ? sub(endDate, { days: 29 }) : undefined;
  }, [endDate]);

  const disabledButtons = useMemo(() => !isValid(startDate) || !isValid(endDate) || errors, [
    startDate,
    endDate,
    errors
  ]);

  const handleClearSearch = e => {
    e.preventDefault();
    setStartDate(undefined);
    setEndDate(undefined);
    setErrors(null);
    onSearchByDateRange();
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!errors) {
      onSearchByDateRange({
        dateStart: formatISO(startOfDay(new Date(startDate))),
        dateEnd: formatISO(endOfDay(new Date(endDate)))
      });
    }
  };

  const handleValidateDate = (field, value) => {
    const errors = {
      default: 'Data inválida',
      startDate: 'Você precisa selecionar a data inicial',
      endDate: 'Você precisa selecionar a data final',
    }

    const isValidDate = isValid(value);
    if(!isValidDate) return setErrors({ [field]: errors[field] });
    const formattedDate = startOfDay(new Date(value));
    const minDate = field === 'startDate' ? minStartDate : startDate;
    const maxDate = field === 'startDate' ? endDate : maxEndDate;
    if (
      !isValidDate ||
      (minStartDate && isBefore(formattedDate, startOfDay(minDate)))||
      (maxEndDate && isAfter(formattedDate, startOfDay(maxDate)))
    ) {
      return setErrors({ [field]: errors.default });
    };
    return setErrors(null);
  };

  const handleChangeStartDate = e => {
    setStartDate(e)
    handleValidateDate('startDate', e)
  };

  const handleChangeEndDate = e => {
    setEndDate(e)
    handleValidateDate('endDate', e)
  };

  return (
    <Container onSubmit={e => handleSubmit(e)}>
       <ModalDeactive openCalendar={openCalendar} />
      <DateRangeContainer>
        <DateField
          id="searchDateRange-startDate-inputDate"
          data-testid="searchDateRange-startDate-inputDate"
          label="Data Inicial"
          value={startDate}
          minDate={minStartDate}
          maxDate={endDate}
          onChange={handleChangeStartDate}
          autoFocus
          variant={errors && errors.startDate ? 'error' : 'default'}
          hint={errors && errors.startDate}
          onToggleModalHandler={() => setOpenCalendar(!openCalendar)}
        />
        <DateField
          name="endDate"
          id="searchDateRange-endDate-inputDate"
          data-testid="searchDateRange-endDate-inputDate"
          label="Data Final"
          placeholder="Selecionar"
          value={endDate}
          onChange={handleChangeEndDate}
          minDate={startDate}
          maxDate={maxEndDate}
          variant={errors && errors.endDate ? 'error' : 'default'}
          hint={errors && errors.endDate}
          onToggleModalHandler={() => setOpenCalendar(!openCalendar)}
        />
        {!errors && <HelpText>Você pode selecionar um período de até 30 dias</HelpText>}
      </DateRangeContainer>
      <Button
        id="searchDateRange-submit-button"
        data-testid="searchDateRange-submit-button"
        type="submit"
        variant="primary"
        size="big"
        disabled={disabledButtons}
      >
        Aplicar
      </Button>
      <Link
        id="searchDateRange-clear-button"
        data-testid="searchDateRange-clear-button"
        onClick={e => handleClearSearch(e)}
      >
        Limpar
      </Link>
    </Container>
  );
};

export default SearchDateRange;
